<h1 mat-dialog-title>{{ 'MASSIVE_COMPANY_DIALOG.MASSIVE_COMPANY_IMPORT' | translate }}</h1>

<mat-dialog-content>
  <mat-horizontal-stepper #stepper class="stepper">

    <mat-step [label]="'MASSIVE_COMPANY_DIALOG.CREATION' | translate">
      <div fxFlexFill fxLayout="column">

        <form [formGroup]="textImportForm" fxLayout="column" fxLayoutGap="16px">

          <div fxLayout="row" fxLayoutGap="32px">
            <mat-form-field appearance="fill" fxFlex="360px">
              <mat-label>{{ 'MASSIVE_COMPANY_DIALOG.COMPANY_TYPE' | translate }}</mat-label>
              <mat-select formControlName="mainCompanyType">
                <mat-option [value]="CompanyImportType.seller_debtor">
                  <span>{{ 'MASSIVE_COMPANY_DIALOG.COMPANY_IMPORT_TYPE_SELLER_DEBTOR' | translate }}</span>
                </mat-option>
                <ng-container *ngIf="allowDebtorCreate && allowDebtorParameters">
                  <mat-option [value]="CompanyImportType.debtor_seller">
                    <span>{{ 'MASSIVE_COMPANY_DIALOG.COMPANY_IMPORT_TYPE_DEBTOR_SELLER' | translate }}</span>
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>

            <div class="description">
              <ng-container [ngSwitch]="textImportForm.get('mainCompanyType').value">
                <div *ngSwitchCase="CompanyImportType.seller_debtor">
                  <p [innerHTML]="'MASSIVE_COMPANY_DIALOG.DESCRIPTION_SELLER_DEBTOR_1' | translate"></p>
                  <p [innerHTML]="'MASSIVE_COMPANY_DIALOG.DESCRIPTION_SELLER_DEBTOR_2' | translate"></p>
                </div>
                <div *ngSwitchCase="CompanyImportType.debtor_seller">
                  <p [innerHTML]="'MASSIVE_COMPANY_DIALOG.DESCRIPTION_DEBTOR_SELLER_1' | translate"></p>
                  <p [innerHTML]="'MASSIVE_COMPANY_DIALOG.DESCRIPTION_DEBTOR_SELLER_2' | translate"></p>
                </div>
                <div *ngSwitchCase="CompanyImportType.seller">
                  <p [innerHTML]="'MASSIVE_COMPANY_DIALOG.DESCRIPTION_SELLER' | translate"></p>
                </div>
                <div *ngSwitchCase="CompanyImportType.debtor">
                  <p [innerHTML]="'MASSIVE_COMPANY_DIALOG.DESCRIPTION_DEBTOR' | translate"></p>
                </div>
              </ng-container>
            </div>
          </div>

          <mat-form-field appearance="fill" class="text-area">
            <textarea
              matInput
              formControlName="text"
              rows="8"
              placeholder="Rossi S.p.A. IT01234567890&#13;...">
            </textarea>
          </mat-form-field>

        </form>

        <span class="separator"></span>

        <div fxLayout="column" fxLayoutGap="16px">

          <div>{{ 'MASSIVE_COMPANY_DIALOG.ALTERNATIVE' | translate }}</div>

          <div fxLayout="row">
            <button
              mat-button
              color="accent"
              (click)="downloadXlsTemplate()"
              [disabled]="isLoading">
              <mat-icon>file_download</mat-icon>
              <span>&nbsp;</span>
              <span>{{ 'MASSIVE_COMPANY_DIALOG.DOWNLOAD_TEMPALTE' | translate }}</span>
            </button>
          </div>

          <form [formGroup]="xlsImportForm" fxLayout="row" fxLayoutAlign="start start" style="position: relative">
            <input #fileInput (change)="onFileChange($event)" hidden type="file">
            <button mat-flat-button
                    color="primary"
                    (click)="fileInput.click()"
                    [disabled]="isLoading"
                    class="template-btn">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.BROWSE' | translate }}</span>
            </button>

            <mat-form-field fxFlex="300px" class="template-file">
              <input matInput formControlName="fileName" readonly>
            </mat-form-field>

            <button
              mat-flat-button
              color="accent"
              fxFlexOffset="16px"
              (click)="submitXls()"
              [disabled]="isLoading || xlsImportForm.invalid">
              <mat-icon>file_upload</mat-icon>
              <span>&nbsp;</span>
              <span>{{ 'MASSIVE_COMPANY_DIALOG.IMPORT_FILE' | translate }}</span>
            </button>

            <div *ngIf="xlsImportForm.get('file').value" class="hint">
              <span>{{ 'MASSIVE_COMPANY_DIALOG.ATTENTION' | translate }}&nbsp;<strong>{{ CompanyImportTypeLabel.get($any(textImportForm.get('mainCompanyType').value)) | translate }}</strong></span>
            </div>

          </form>

        </div>

      </div>
    </mat-step>

    <mat-step [label]="'MASSIVE_COMPANY_DIALOG.VERIFICATION' | translate">
      <ng-container *ngIf="!!jobStatus">
        <app-massive-company-import-view [jobStatus]="jobStatus"></app-massive-company-import-view>
      </ng-container>
    </mat-step>

    <mat-step [label]="'MASSIVE_COMPANY_DIALOG.INSERTION' | translate">
      <ng-container *ngIf="!!jobStatus && stepper.selectedIndex === 2">
        <app-massive-company-import-update [jobStatus]="jobStatus"
                                           (formReady)="onFormReady($event)"></app-massive-company-import-update>
      </ng-container>
    </mat-step>

    <mat-step [label]="'MASSIVE_COMPANY_DIALOG.VALIDATION' | translate">
      <ng-container *ngIf="!!jobStatus && stepper.selectedIndex === 3">
        <div *ngIf="hasMainCompany; else unrelatedValidation">
          <app-massive-company-validation
            [jobStatus]="jobStatus"
            (formReady)="onFormReady($event)">
          </app-massive-company-validation>
        </div>
        <ng-template #unrelatedValidation>
          <app-massive-company-unrelated-validation
            [jobStatus]="jobStatus"
            (formReady)="onFormReady($event)">
          </app-massive-company-unrelated-validation>
        </ng-template>
      </ng-container>
    </mat-step>

    <mat-step [label]="'MASSIVE_COMPANY_DIALOG.IMPORT_OUTCOME' | translate">
      <ng-container *ngIf="!!jobStatus && stepper.selectedIndex === 4">
        <app-massive-company-import-outcome
          [jobStatus]="jobStatus">
        </app-massive-company-import-outcome>
      </ng-container>
    </mat-step>

  </mat-horizontal-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    color="warn"
    [mat-dialog-close]="undefined"
    [disabled]="isLoading">
    <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.CANCEL' | translate }}</span>
  </button>

  <span fxFlex></span>

  <ng-container *ngIf="stepper.selectedIndex === 0">
    <button
      mat-flat-button
      color="accent"
      (click)="submitText()"
      [disabled]="isLoading || textImportForm.invalid">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.SEND' | translate }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="stepper.selectedIndex === 1">
    <button
      mat-button
      (click)="previousStepper()"
      [disabled]="isLoading">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.BACK' | translate }}</span>
    </button>

    <button
      mat-flat-button
      color="accent"
      (click)="navigateNextAfterVerifyStep()"
      [disabled]="jobStatus?.status !== JobStatus.COMPLETED">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.CONFIRM' | translate }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="stepper.selectedIndex === 2">
    <div *ngIf="checkZeroValue()"
         fxLayout="row"
         fxLayoutAlign="start center"
         fxLayoutGap="8px"
         class="warning orange-600-fg">
      <mat-icon>warning</mat-icon>
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ERROR.ZERO' | translate }}</span>
    </div>

    <span fxFlex="8px"></span>

    <button
      mat-button
      (click)="stepper.previous()"
      [disabled]="isLoading">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.BACK' | translate }}</span>
    </button>

    <button
      mat-flat-button
      color="accent"
      (click)="updateCompanies()"
      [disabled]="isLoading || form.invalid">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.CONFIRM' | translate }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="stepper.selectedIndex === 3">
    <button
      mat-button
      (click)="previousStepper()"
      [disabled]="isLoading">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.BACK' | translate }}</span>
    </button>

    <button
      mat-flat-button
      color="accent"
      (click)="validateCompanies()"
      [disabled]="isLoading || form.invalid">
      <span>{{ 'MASSIVE_COMPANY_DIALOG.ACTION.CONFIRM' | translate }}</span>
    </button>
  </ng-container>

</mat-dialog-actions>
